import { safeJsonParse } from "./utils.js";

export function createStorage(storageKey) {
  let memoryState = null;

  function canUseLocalStorage() {
    try {
      const key = "__readabler_lite_test__";
      window.localStorage.setItem(key, "1");
      window.localStorage.removeItem(key);
      return true;
    } catch {
      return false;
    }
  }

  const useLocalStorage = canUseLocalStorage();

  function load() {
    if (useLocalStorage) {
      return safeJsonParse(window.localStorage.getItem(storageKey), null);
    }
    return memoryState;
  }

  function save(value) {
    if (useLocalStorage) {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
      return;
    }
    memoryState = value;
  }

  function reset() {
    if (useLocalStorage) {
      window.localStorage.removeItem(storageKey);
      return;
    }
    memoryState = null;
  }

  return {
    load,
    save,
    reset,
    isPersistent: useLocalStorage,
  };
}

